import { Text } from "@mantine/core"
import { createColumnHelper } from "@tanstack/react-table"
import { Missing } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { CountryCell } from "~/components/cells/CountryCell.tsx"

const columnHelper =
  createColumnHelper<LibraryResponses.SupplierProductionSiteInfo>()

export const useColumns = (prodsiteFieldKeys: string[]) => {
  const { t } = useTranslation("suppliers")

  return useMemo(
    () => [
      columnHelper.accessor("name", {
        id: "name",
        header: t("productionSites.columns.name"),
        cell: (info) => <Text>{info.getValue()}</Text>,
      }),

      columnHelper.accessor("address", {
        id: "address",
        header: t("productionSites.columns.address"),
        cell: (info) => <Text>{info.getValue()}</Text>,
      }),

      columnHelper.accessor("country", {
        id: "country",
        header: t("productionSites.columns.country"),
        cell: (info) => {
          const country = info.getValue()

          return <CountryCell countryIso3166={country} w="100%" />
        },
      }),
      columnHelper.accessor("email", {
        id: "supplier",
        header: t("productionSites.columns.contactEmail"),
        cell: ({ row }) => {
          if (row.original.confidential) {
            return t("productionSites.columns.confidential")
          }
          return row.original.email
        },
      }),
      ...Object(
        prodsiteFieldKeys.map((prodsiteFieldKey) => {
          return columnHelper.accessor(
            (row) => {
              return row.prodSiteFields.find(
                (psf) => psf.key === prodsiteFieldKey
              )?.value
            },
            {
              id: prodsiteFieldKey + "-id",
              header: prodsiteFieldKey,
              enableSorting: false,
              cell: (info) =>
                !info.getValue() ? <Missing c="gray" /> : info.getValue(),
            }
          )
        })
      ),
    ],
    [t, prodsiteFieldKeys]
  )
}
